export function isFakeOrgNumber(number?: string): boolean {
	return !!number && number.startsWith('NO')
}
